import React, { useEffect, useState, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

// ✅ Critical Components - Immediately loaded
import Home from './Home/Home';
import Header from './Home/HeaderComponent/Header';
import Navbars from './Home/HeaderComponent/NavbarsComponent/Navbars';
import EnquiryForm from '../src/Apply/EnquiryForm.jsx';

// ✅ Lazy Load All Other Components - Sirf zaroorat par load honge
const Contact = lazy(() => import('./Contact/Contact'));
const IQAC = lazy(() => import('./IQAC/Iqac'));
const Report = lazy(() => import('./IQAC/Report'));
const Affiliation = lazy(() => import('./About US/Affiliation'));
const Vision_Mission = lazy(() => import('./About US/Vision_Mission'));
const Infrastructure = lazy(() => import('./About US/infrastructure/Infrastructure'));
const Overview = lazy(() => import('./About US/overview/Overview'));
const Message = lazy(() => import('./About US/Message/Message'));
const Gallery = lazy(() => import('./About US/Gallery/Gallery'));
const Course = lazy(() => import('./Academics/Course/Course'));
const Admission = lazy(() => import('./Academics/Admission'));
const Computerlab = lazy(() => import('./Department/ComputerLab/Computerlab.jsx'));
const Civil = lazy(() => import('./Department/Civil/Civil.jsx'));
const Computer = lazy(() => import('./Department/ComputerScience/Computer.jsx'));
const Electrical = lazy(() => import('./Department/Electrical/Electrical.jsx'));
const Mechanical = lazy(() => import('./Department/Mechanical/Mechanical.jsx'));
const Electronic = lazy(() => import('./Department/Electronic/Electronic.jsx'));


const Download = lazy(() => import('./Academics/Download/Download.jsx'));
const Notice = lazy(() => import('./IQAC/Notice/Notice.jsx'));
const NEWS = lazy(() => import('./News/News.jsx'));
const Placement = lazy(() => import('./Placement/Placement.jsx'));
const Naac = lazy(() => import('./IQAC/naac/Naac.jsx'));
const Naac_2 = lazy(() => import('./IQAC/naac2a/Naac_2.jsx'));
const Naac_2b = lazy(() => import('./IQAC/naac2b/Naac_2b.jsx'));
const Placementlist = lazy(() => import('./Placement/placementlist/Placementlist.jsx'));
const AdmissionForm = lazy(() => import("./component/AdmissionForm"));
const AdminLogin = lazy(() => import("./component/AdminLogin"));
const AdminPanel = lazy(() => import("./component/AdminPanel"));
const Step = lazy(() => import("./component/Step"));
const Account = lazy(() => import("./component/Account"));
const Notices = lazy(() => import("./notice/Notices.jsx"));
const Syllabus = lazy(() => import("./Academics/Syllabus/Syllabus.jsx"));

// ✅ Loading Component - Jab component load ho raha ho tab yeh dikhega
const PageLoader = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: 'linear-gradient(135deg, #0a2472, #1e3a8a)'
  }}>
    <div style={{
      width: '50px',
      height: '50px',
      border: '5px solid #fbbf24',
      borderTop: '5px solid transparent',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    }} />
    <style>{`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

AOS.init({
  offset: 120,
  delay: 0,
  duration: 1000,
  easing: 'ease',
  once: false,
  mirror: false,
  anchorPlacement: 'top-bottom',
  loop: true,
});

function App() {
  const [showEnquiryForm, setShowEnquiryForm] = useState(false);
  const [loggedIn, setLoggedIn] = useState(!!localStorage.getItem("token"));

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowEnquiryForm(true);
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  const closeModal = () => {
    setShowEnquiryForm(false);
  };

  return (
    <Router>
      <Header />
      <Navbars />
      
      {/* ✅ Suspense Wrapper - Lazy loaded components yahan wrap honge */}
      <Suspense fallback={<PageLoader />}>
        <Routes>
          {/* Home Route - Already loaded */}
          <Route path="/" element={<Home />} />
          
          {/* All Other Routes - Lazy Loaded */}
          <Route path="/contact" element={<Contact />} />
          <Route path="/Iqac" element={<IQAC />} />
          <Route path="/Report" element={<Report />} />
          <Route path="/Affiliation" element={<Affiliation />} />
          <Route path="/Vision_Mission" element={<Vision_Mission />} />
          <Route path="/Infrastructure" element={<Infrastructure />} />
          <Route path="/Overview" element={<Overview />} />
          <Route path="/Message" element={<Message />} />
          <Route path="/Gallery" element={<Gallery />} />
          <Route path="/Course" element={<Course />} />
          <Route path="/Admission" element={<Admission />} />
          <Route path="/Civil" element={<Civil />} />
          <Route path="/Computer" element={<Computer />} />
          <Route path="/Electrical" element={<Electrical />} />
          <Route path="/Mechanical" element={<Mechanical />} />
          <Route path="/Electronic" element={<Electronic />} />
          <Route path="/Computerlab" element={<Computerlab />} />
          
         
          <Route path="/Download" element={<Download />} />
          <Route path="/NEWS" element={<NEWS />} />
          <Route path="/Placement" element={<Placement />} />
          <Route path="/Notice" element={<Notice />} />
          <Route path="/Naac" element={<Naac />} />
          <Route path="/Naac_2" element={<Naac_2 />} />
          <Route path="/Naac_2b" element={<Naac_2b />} />
          <Route path="/Placementlist" element={<Placementlist />} />
          <Route path="/Step" element={<Step />} />
          <Route path="/AdmissionForm" element={<AdmissionForm />} />
          <Route path="/Account" element={<Account />} />
          <Route path="/Notices" element={<Notices />} />
          <Route path="/Syllabus" element={<Syllabus />} />

          <Route
            path="/AdminLogin"
            element={<AdminLogin onLogin={() => setLoggedIn(true)} />}
          />

          <Route
            path="/AdminPanel"
            element={loggedIn ? <AdminPanel /> : <Navigate to="/AdminLogin" />}
          />
        </Routes>
      </Suspense>
      
      {showEnquiryForm && <EnquiryForm closeModal={closeModal} />}
    </Router>
  );
}

export default App;